// extracted by mini-css-extract-plugin
module.exports = {"Navigation":"Navigation_Navigation__1tTPb","Link":"Navigation_Link__1hxEK","Active":"Navigation_Active__2gNvH"};